import { Box, Typography } from '@mui/material'
import CloseSidebar from '@assets/flowchart/CloseSidebar.svg'
import OpenSidebar from '@assets/flowchart/OpenSidebar.svg'
import { useAppTheme } from '@/theme/ThemeContext'

const Items = ({
  title,
  icon,
  onClick,
}: {
  title: string
  icon: string
  onClick: () => void
}) => {
  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'
  
  const colors = {
      itemBg: isDarkMode ? '#162645' : '#FAFBFD',
      text: isDarkMode ? '#FFFFFF' : 'inherit',
      border: isDarkMode ? '#445876' : 'rgba(50, 59, 119, 0.10)',
      iconFilter: 'none',
  }
  
  return (
    <Box
      sx={{
        width: '250px',
        display: 'flex',
        justifyContent: 'flex-end',
        borderRadius: '4.5px',
        border: `1px solid ${colors.border}`,
        background: colors.itemBg,
        gap: '16px',
        alignItems: 'center',
        py: '12px',
        px: '16px',
        marginBottom: '13px',
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      <Typography sx={{fontFamily: 'Rubik, sans-serif', color: colors.text}}>{title}</Typography>
      <img src={icon} alt={title} style={{ filter: colors.iconFilter }} />
    </Box>
  )
}
const Sidebar = ({
  items,
  handleAddNode,
  openSidebar,
  setOpenSidebar,
}: {
  items: any
  handleAddNode: any
  openSidebar: boolean
  setOpenSidebar: (openSidebar: boolean) => void
}) => {
    const { mode } = useAppTheme()
    const isDarkMode = mode === 'dark'
    
    const colors = {
      sidebarBg: isDarkMode ? '#1D325A' : '#EFF2F7',
      divider: isDarkMode ? '#374151' : '#E4E7EB',
      title: isDarkMode ? '#FFFFFF' : '#003F61',
      openIconFilter: isDarkMode ? 'brightness(0) invert(1)' : 'none',
      itemBg: isDarkMode ? '#162645' : '#FAFBFD',
      itemBorder: isDarkMode ? '#445876' : 'rgba(50, 59, 119, 0.10)',
    }

  return (
    <Box
      position="relative"
      height="100%"
      sx={{
        background: colors.sidebarBg,
        width: 'fit-content',
        px: '13px',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          right: -50,
          top: 60,
          width: 'fit-content',
          zIndex: 999999,
        }}
        style={{ cursor: 'pointer' }}
        onClick={() => setOpenSidebar(!openSidebar)}
      >
        {openSidebar ? (
          <img src={CloseSidebar} alt="close sidebar" style={{ filter: colors.openIconFilter }} />
        ) : (
          <img
            style={{ marginLeft: '30px', filter: colors.openIconFilter }}
            src={OpenSidebar}
            alt="open sidebar"
          />
        )}
      </Box>
      <Box
        sx={{
          borderBottom: `1px solid ${colors.divider}`,
          padding: '8px',
          paddingTop: '59px',
          marginBottom: '22px',
        }}
      >
        <Typography
          sx={{
            color: colors.title,
            textAlign: 'right',
            fontFamily: 'Rubik, sans-serif',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
          }}
        >
          רכיבים
        </Typography>
      </Box>
      {items.map((item: any) => (
        <Items
          key={item.id}
          title={item.title}
          icon={item.icon}
          onClick={() => handleAddNode(item.type)}
        />
      ))}
    </Box>
  )
}

export default Sidebar
